<script>
export default {
  name: 'OPINION_CHANGED_BY_MEMBER',
  props: {
    news: {
      type: Object,
    },
  },
};
</script>

<template>
  <div>
    <router-link
      :to="{name: 'userpage', params: {type: 'profile', id: news.textParams[0]}}"
    >{{ news.textParams[1] }}
    </router-link>
    {{$t('news.template.opinion.changedByMember.p1')}}
    "
    <router-link
      :to="{name: 'OpinionView', params: {hash: news.textParams[2]}}"
    >{{ news.textParams[3] }}
    </router-link>
    "
    {{$t('news.template.opinion.changedByMember.p2')}}
    "
    <router-link :to="{name: 'OpinionView', params: {hash: news.textParams[2]}}">
      {{ news.textParams[4] }}
    </router-link>
    "
  </div>
</template>
